import { useState } from 'react';
import { safeJsonParse } from '../utils/safeJsonParse';

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T | any | null>(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      if (item) {
        if (typeof item !== 'object') return item;
        return safeJsonParse<T>(item, initialValue);
      }
      return initialValue;
    } catch (e) {
      return initialValue;
    }
  });

  const setValue = (value: T | null | ((val: T | null) => T | null)) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(
        key,
        typeof value === 'string'
          ? String(valueToStore)
          : JSON.stringify(valueToStore),
      );
    }
  };
  return [storedValue, setValue] as const;
}
